import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leaderboard',
  templateUrl: './leaderboard.component.html',
  styleUrls: ['./leaderboard.component.scss']
})
export class LeaderboardComponent implements OnInit {
  public isSkeletonLeaders = true;
  public isSkeletonLeadersSm = true;

  constructor() { }

  ngOnInit(): void {
    setTimeout(() => {
      this.isSkeletonLeaders = false;
      this.isSkeletonLeadersSm = false;

    }, 3000);
  }

}
